import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputAdornment,
  InputLabel,
  makeStyles,
  Paper,
  SvgIcon,
  TextField,
  withStyles
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS_API } from 'src/app/constant/config';
import { showToast } from 'src/features/uiSlice';
import { useQuery } from '../hooks/useQuery';
import theme from '../theme';
import DateTimeAntd from './input/DateTimeAntd';
import ToastMessage from './ToastMessage';

const useStyles = makeStyles(theme => ({
  root: {
    height: 'fit-content',
    width: 352,
    boxShadow: 'none'
  },
  inputRoot: {
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
      padding: '4px'
    }
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  searchInput: {
    width: '100%'
  },
  option: {
    fontSize: '14px',
    borderBottom: '1px solid #e0e0e0',
    paddingTop: 6,
    paddingBottom: 6,

    '&:last-child': {
      borderBottom: 'none'
    }
  },
  iconButton: {
    padding: 10
  },
  divider: {
    height: 28,
    margin: 4
  },
  titleLotrinh: {
    fontSize: '18px',
    color: theme.palette.primary.main,
    fontWeight: 700,
    marginBottom: '10px'
  },
  titleTime: {
    fontSize: '16px',
    color: '#0C1132',
    fontWeight: 600
  },
  formControl: {
    width: 352,
    marginTop: '10px',
    marginBottom: '10px'
  },
  titleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textRed: {
    color: 'red'
  },
  customOutline: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#D6D9DB',
        borderWidth: 1
      },
      '&:hover fieldset': {
        borderColor: '#D9042F'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#D9042F'
      }
    }
  }
}));

const CssTextField = withStyles({
  root: {
    '& .MuiInput-underline:after': {
      borderBottomColor: '#D6D9DB'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#D6D9DB'
      },
      '&:hover fieldset': {
        borderColor: '#D9042F'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#D9042F'
      }
    }
  }
})(TextField);

const ToolBarRoadMap = ({ GetVehiclePosition, resetTracking }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const query = useQuery();
  const deviceTypeId = query.get('device_type_id') || 0;

  const statusGetPositions = useSelector(
    state => state.deviceSlice.statusGetPositions
  );
  const isTooManyRequest = useSelector(
    state => state.deviceSlice.isTooManyRequest
  );
  const listLicensePlate = useSelector(
    state => state.deviceSlice.listLicensePlate
  );

  const timeSearching = useSelector(state => state.deviceSlice.timeSearching);

  useEffect(() => {
    if (isTooManyRequest) {
      dispatch(showToast());
    }
  }, [isTooManyRequest]);

  useEffect(() => {
    if (timeSearching && timeSearching.id) {
      const hour = timeSearching.data.value;

      let startDate, endDate;

      if (hour === 24) {
        startDate = moment().subtract(1, 'day').startOf('day');
        endDate = moment().subtract(1, 'day').endOf('day');
      } else if (hour === 'today') {
        startDate = moment().startOf('day');
        endDate = moment();
      } else if (hour) {
        endDate = moment();
        startDate = moment(endDate).subtract(hour, 'hour');
      } else {
        startDate = moment().startOf('day');
        endDate = moment();
      }

      const newQuery = {
        device_id: timeSearching.id,
        license_plate: timeSearching.license_plate,
        start_date: startDate,
        end_date: endDate
      };
      setQueryTracking(newQuery);
    }
  }, [timeSearching]);

  const filteredList = listLicensePlate.filter(
    plate => plate.license_plate !== null
  );

  const initialState = {
    device_id: null,
    license_plate: null,
    device_type_id: deviceTypeId,
    start_date: moment().startOf('day'),
    end_date: moment()
  };

  const [queryTracking, setQueryTracking] = useState(initialState);
  const [tooManyDays, setTooManyDays] = useState(false);

  const ConvertTime = date => {
    return Math.floor(
      moment(date)
        .utcOffset(0)
        .unix()
    );
  };

  const handleSearchDevice = (deviceId, startTime, endTime) => {
    resetTracking();
    const startTimeZone0 = ConvertTime(startTime);
    const endTimeZone0 = ConvertTime(endTime);
    const diffInDays = moment(endTimeZone0 * 1000).diff(
      moment(startTimeZone0 * 1000),
      'days'
    );

    if (diffInDays > 5) {
      setTooManyDays(true);
      dispatch(showToast());
    } else {
      const data = {
        id: Number(deviceId),
        first_time: startTimeZone0,
        last_time: endTimeZone0
        // id: 1578,
        // first_time: '1752080401',
        // last_time: '1752121274'
      };
      GetVehiclePosition(data);
    }
  };

  const handleChangeDevice = (event, value) => {
    if (value) {
      setQueryTracking({
        ...queryTracking,
        device_id: Number(value.device_id),
        license_plate: value.license_plate
      });
    }
  };

  const disabledLoadRoadMap = () => {
    if (!queryTracking.device_id) {
      return true;
    }
    return statusGetPositions === STATUS_API.PENDING;
  };

  const handleClearInput = () => {
    setQueryTracking({
      ...queryTracking,
      device_id: null
    });
  };

  const onChangeStartTime = value => {
    setQueryTracking({
      ...queryTracking,
      start_date: value
    });
  };

  const onChangeEndTime = value => {
    setQueryTracking({
      ...queryTracking,
      end_date: value
    });
  };

  const onOk = value => { };

  return (
    <>
      {tooManyDays && (
        <ToastMessage
          message={'Hệ thống chỉ hỗ trợ tìm kiếm trong khoảng 5 ngày'}
          type={'warning'}
          callBack={() => { }}
        />
      )}

      {isTooManyRequest && (
        <ToastMessage
          message={
            'Có quá nhiều yêu cầu truy cập, vui lòng thử lại sau ít phút!'
          }
          type={'error'}
          callBack={() => { }}
        />
      )}

      <Paper component="form" className={classes.root}>
        <FormControl size="small" className={classes.formControl}>
          <div>
            {filteredList && (
              <Autocomplete
                freeSolo
                id="free-solo-2-demo"
                size="small"
                disableClearable
                options={filteredList}
                getOptionLabel={option => option.license_plate}
                onChange={(e, value) => handleChangeDevice(e, value)}
                value={
                  queryTracking.device_id
                    ? filteredList.find(
                      item =>
                        item.device_id === Number(queryTracking.device_id)
                    )
                    : null
                }
                classes={{ option: classes.option }}
                className={classes.inputRoot}
                renderInput={params => (
                  <CssTextField
                    {...params}
                    //margin="dense"
                    required={true}
                    className={classes.searchInput}
                    variant="outlined"
                    placeholder="Nhập biển số để tìm kiếm ..."
                    onChange={handleChangeDevice}
                    InputProps={{
                      ...params.InputProps,
                      style: {
                        fontSize: '14px',
                        height: '36px'
                      },
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          style={{
                            cursor: 'pointer'
                          }}
                        >
                          <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <>
                          {queryTracking.device_id && (
                            <InputAdornment
                              position="end"
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleClearInput()}
                            >
                              <SvgIcon fontSize="small" color="action">
                                <ClearIcon />
                              </SvgIcon>
                            </InputAdornment>
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      )
                    }}
                  />
                )}
              />
            )}
          </div>
        </FormControl>
        <div>
          <span className={classes.titleTime}>Chọn khoảng thời gian</span>
          <FormControl variant="outlined" className={classes.formControl}>
            <form noValidate>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: '12px'
                }}
              >
                <InputLabel
                  style={{
                    fontSize: '14px',
                    position: 'relative',
                    top: -30,
                    left: -13
                  }}
                >
                  Từ ngày
                </InputLabel>

                <DateTimeAntd
                  showTime={true}
                  format={'DD-MM-YYYY HH:mm'}
                  dateTime={queryTracking.start_date}
                  onChange={onChangeStartTime}
                  onOk={onOk}
                />
              </Box>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: '22px'
                }}
              >
                <InputLabel
                  style={{
                    fontSize: '14px',
                    position: 'relative',
                    top: -30,
                    left: -13
                  }}
                >
                  Đến ngày
                </InputLabel>
                <DateTimeAntd
                  showTime={true}
                  format={'DD-MM-YYYY HH:mm'}
                  dateTime={queryTracking.end_date}
                  onChange={onChangeEndTime}
                  onOk={onOk}
                />
              </Box>
            </form>
          </FormControl>
        </div>
        <Button
          style={{
            background: theme.palette.primary.main,
            color: '#fff',
            textTransform: 'inherit',
            fontSize: '16px',
            width: 352,
            marginTop: '12px'
          }}
          disabled={disabledLoadRoadMap()}
          variant="contained"
          onClick={() => {
            handleSearchDevice(
              queryTracking.device_id,
              queryTracking.start_date,
              queryTracking.end_date
            );
          }}
        >
          {statusGetPositions === STATUS_API.PENDING ? (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={24} style={{ color: 'white' }} />
              <span> Vui lòng đợi ...</span>
            </Box>
          ) : (
            <span>Tải lộ trình</span>
          )}
        </Button>
      </Paper>
    </>
  );
};

export default React.memo(ToolBarRoadMap);
